import React, { useState } from "react";
import Box from "@mui/material/Box";
import { ClickAwayListener } from "@mui/material";
import { menuItems } from "../../../config/menuItems";
import Navbar from "../Navbar/navbar";
import Sidebar from "../Sidebar/sidebar";
import Footer from "../Footer/Footer";
import { NetworkSnackbar } from "../Network/NetworkSnackbar";

interface LayoutProps {
    children: React.ReactNode;
}

const NAVBAR_HEIGHT = "70px";

const Layout: React.FC<LayoutProps> = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

    const handleClickAway = () => {
        if (sidebarOpen) {
            setSidebarOpen(false);
        }
    };

    return (
        <Box>
            <Box className="flex" >
                <ClickAwayListener onClickAway={handleClickAway}>
                    <Box>
                        <Navbar toggleSidebar={toggleSidebar} />
                        <Sidebar
                            isOpen={sidebarOpen}
                            menuItems={menuItems}
                            setSidebarOpen={setSidebarOpen}
                        />
                    </Box>
                </ClickAwayListener>
                <NetworkSnackbar />
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        backgroundColor: "#F1F5F7",
                        transition: "margin 0.3s",
                        paddingTop: NAVBAR_HEIGHT,
                    }}
                >
                    {children}
                </Box>
            </Box>
            <Footer />
        </Box>
    );
};

export default Layout;